var map = {
	"./1-a.png": "9d6d",
	"./10-a.png": "1388",
	"./2-a.png": "073f",
	"./3-a.png": "cd88",
	"./4-a.png": "6bec8",
	"./5-a.png": "1635",
	"./6-a.png": "c476",
	"./7-a.png": "f65f",
	"./8-a.png": "f896",
	"./9-a.png": "9e86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0634";